import React, { Component } from 'react';
import Presenter from './presenter';
import Model from './model';
import View from './view';

export default class LoginLanding extends Component {
  constructor(props) {
    super(props);
    const { config, onLogin, initialToken } = props;
    this.presenter = new Presenter(
      new Model(this, {
        inputValue: initialToken || '',
        errorText: null,
        allowEmail: false,
        allowPhone: false,
        countryCode: null,
        showCountryCode: false,
        disableCountryPicker: false,
        loading: false,
        showFacebook: false,
        showGoogle: false,
        showSamsung: false,
        showOutsideOauth: false,
        oauthOnly: false,
        authButtonOrder: [],
      }),
      config,
      onLogin
    );
  }

  componentDidMount() {
    this.presenter.onAttach();
  }

  componentDidUpdate(prevProps) {
    const { initialToken } = this.props;
    if (initialToken !== prevProps.initialToken) {
      this.presenter.onInitialTokenChange(initialToken);
    }
  }

  render() {
    const { config } = this.props;
    return (
      <View
        {...this.state}
        presenter={this.presenter}
        defaultCampaign={config.login.default_campaign}
      />
    );
  }
}
